import React from "react";

// Calm, flat card used across the NHL Game Centre summary.
export function StCard({ title, icon: Icon, testId, right = null, children }) {
    return (
        <div className="relative rounded-xl border border-white/10 bg-[#0E0F16] p-3.5" data-testid={testId}>
            <div className="space-y-3">
                {title && (
                    <div className="flex items-center gap-2">
                        {Icon && <Icon className="h-4 w-4 text-white/60" />}
                        <h3 className="text-xs font-black uppercase tracking-wider text-white">{title}</h3>
                        {right && <div className="ml-auto">{right}</div>}
                    </div>
                )}
                {children}
            </div>
        </div>
    );
}

// Flat tile with a thin team-colour edge.
export const TeamTile = ({ c, className = "", children, testId, ...rest }) => (
    <div className={`rounded-lg bg-white/[0.03] border border-white/[0.07] px-3 py-2.5 ${className}`} style={{ borderLeft: `3px solid ${c}` }} data-testid={testId} {...rest}>{children}</div>
);
